import React, { useState } from 'react';
import WelcomePage from '../components/WelcomePage/WelcomePage';

const WelcomePageContainer = () => {
    const [isSignupVisible, setIsSignupVisible] = useState(false);

    const toggleForm = () => {
        setIsSignupVisible(!isSignupVisible);
    };

    return (
        <div className="WelcomePageContainer">
            <WelcomePage isSignupVisible={isSignupVisible} toggleForm={toggleForm} />
        </div>
    );
}

export default WelcomePageContainer;